import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Dashboard = props => {
  // Date range for Bonus
  const [bonusDateFrom, setBonusDateFrom] = React.useState(null);
  const [bonusDateTo, setBonusDateTo] = React.useState(null);
  const [TotalBonus, setTotalBonus] = React.useState(0);
  const [WelcomeBonus, setWelcomeBonus] = React.useState(0);
  const [ReferralBonus, setReferralBonus] = React.useState(0);
  const [ManualBonus, setManualBonus] = React.useState(0);
  const [CollaboratorBonus, setCollaboratorBonus] = React.useState(0);
  const [bonusLoading, setBonusLoading] = React.useState(false);
  // Fetch all bonuses (no filter)
  const fetchAllBonuses = async () => {
    setBonusLoading(true);
    let fiatSum = 0;
    let welcomeSum = 0;
    let referralSum = 0;
    let manualSum = 0;
    const fiatRes = await getRequest('get-all-fiat-data');
    if (fiatRes && fiatRes.code === 200 && Array.isArray(fiatRes.data.data)) {
      let Data = fiatRes.data.data;

      let filtered = Data.filter(item => item.description === 'Manually Added' || item.description === 'Welcome Bonus' || item.description.includes('Welcome Bonus from') || item.description.includes('Referral Reward'));
      let welcomeBonusfiltered = Data.filter(item => item.description === 'Welcome Bonus' || item.description.includes('Welcome Bonus from'));
      let referralBonusfiltered = Data.filter(item => item.description.includes('Referral Reward'));
      let manualfiltered = Data.filter(item => item.description === 'Manually Added');

      fiatSum = filtered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      welcomeSum = welcomeBonusfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      referralSum = referralBonusfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      manualSum = manualfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
    }
    setTotalBonus((fiatSum).toFixed(2));
    setWelcomeBonus((welcomeSum).toFixed(2));
    setReferralBonus((referralSum).toFixed(2));
    setManualBonus((manualSum).toFixed(2));
    setCollaboratorBonus((fiatRes.data.collaborator_bonus).toFixed(2));
    setBonusLoading(false);
  };

  // Only filter when button is clicked
  const handleBonusFilter = async () => {
    setBonusLoading(true);
    // If both dates are empty, show all bonuses
    if (!bonusDateFrom && !bonusDateTo) {
      await fetchAllBonuses();
      setBonusLoading(false);
      return;
    }
    let fiatSum = 0;
    let welcomeSum = 0;
    let referralSum = 0;
    let manualSum = 0;
    // Fiat Data
    const fiatRes = await getRequest('get-all-fiat-data');
    if (fiatRes && fiatRes.code === 200 && Array.isArray(fiatRes.data.data)) {
      let Data = fiatRes.data.data;

      let filtered = Data.filter(item => item.description === 'Manually Added' || item.description === 'Welcome Bonus' || item.description.includes('Welcome Bonus from') || item.description.includes('Referral Reward'));
      console.log("Before Filter : ", filtered);
      let welcomeBonusfiltered = Data.filter(item => item.description === 'Welcome Bonus' || item.description.includes('Welcome Bonus from'));
      let referralBonusfiltered = Data.filter(item => item.description.includes('Referral Reward'));
      let manualfiltered = Data.filter(item => item.description === 'Manually Added');

      if (bonusDateFrom) {
        filtered = filtered.filter(item => moment(item.created_at).isSameOrAfter(moment(bonusDateFrom).startOf('day')));
        welcomeBonusfiltered = welcomeBonusfiltered.filter(item => moment(item.created_at).isSameOrAfter(moment(bonusDateFrom).startOf('day')));
        referralBonusfiltered = referralBonusfiltered.filter(item => moment(item.created_at).isSameOrAfter(moment(bonusDateFrom).startOf('day')));
        manualfiltered = manualfiltered.filter(item => moment(item.created_at).isSameOrAfter(moment(bonusDateFrom).startOf('day')));
      }
      if (bonusDateTo) {
        filtered = filtered.filter(item => moment(item.created_at).isSameOrBefore(moment(bonusDateTo).endOf('day')));
        welcomeBonusfiltered = welcomeBonusfiltered.filter(item => moment(item.created_at).isSameOrBefore(moment(bonusDateTo).endOf('day')));
        referralBonusfiltered = referralBonusfiltered.filter(item => moment(item.created_at).isSameOrBefore(moment(bonusDateTo).endOf('day')));
        manualfiltered = manualfiltered.filter(item => moment(item.created_at).isSameOrBefore(moment(bonusDateTo).endOf('day')));
      }
      fiatSum = filtered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      welcomeSum = welcomeBonusfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      referralSum = referralBonusfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
      manualSum = manualfiltered.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
    }
    setTotalBonus((fiatSum).toFixed(2));
    setWelcomeBonus((welcomeSum).toFixed(2));
    setReferralBonus((referralSum).toFixed(2));
    setManualBonus((manualSum).toFixed(2));
    setCollaboratorBonus((fiatRes.data.collaborator_bonus).toFixed(2));
    setBonusLoading(false);
  }
  //meta title
  document.title = "Dashboard";
  const dispatch = useDispatch();
	const location = useLocation();
  const { getRequest } = useRequests();

  const [modal_Fiat_Transaction, setmodal_Fiat_Transaction] = useState(false);
  function Fiat_Transaction() {
    setmodal_Fiat_Transaction(!modal_Fiat_Transaction);
    // removeBodyCss();
  }

  const [modal_Crypto_Transaction, setmodal_Crypto_Transaction] = useState(false);
  function Crypto_Transaction() {
    setmodal_Crypto_Transaction(!modal_Crypto_Transaction);
    // removeBodyCss();
  }



  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [ DashboardNumbers, setDashboardNumbers ] = React.useState({});
  const handleLoadGetDashboardNumbers = async () => {
    const res = await getRequest('get-dashboard-numbers');
    if (res && res.code === 200) {
      setDashboardNumbers(res.data);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const [FilePath, setFilePath] = React.useState('');
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.pct_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.token}</td>
        <td>{element.currency}</td>
        <td>{parseFloat(element.received_amount)} &nbsp;{element.currency}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <span className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></span>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  // Fetch property crypto transactions
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-property-crypto-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data.transaction);
      setFilePath(res.data.url);
    } else {
      let tempTBody = (<tr>
        <td colSpan="10" className="text-center">No records found</td>
      </tr>);
      setTransactionTBody(tempTBody);
    }
  }

  // Fetch dividend transactions and group by property
  const [DividendGrouped, setDividendGrouped] = React.useState([]);
  const [TotalDividendCount, setTotalDividendCount] = React.useState(0);
  const handleLoadDividendTransactions = async () => {
    const res = await getRequest('get-dividend-transaction-data');
    if (res && res.code === 200) {
      // Group by p_id and sum dividend_amount
      const approvedTransactions = res.data.filter(tx => tx.status === 'Approved');
      const grouped = {};
      let totalCount = 0;
      approvedTransactions.forEach(tx => {
        if (!tx.p_id) return;
        if (!grouped[tx.p_id]) {
          grouped[tx.p_id] = {
            p_id: tx.p_id,
            property_name: tx.property_name ,
            total_dividend_amount: 0,
            transactions: [],
          };
        }
        grouped[tx.p_id].total_dividend_amount += parseFloat(tx.dividend_amount || 0);
        grouped[tx.p_id].transactions.push(tx);
        totalCount+=parseFloat(tx.dividend_amount || 0);
      });
      setDividendGrouped(Object.values(grouped));
      setTotalDividendCount((totalCount).toFixed(2));
    }
  }

  const [ClaimGrouped, setClaimGrouped] = React.useState([]);
  const [TotalClaimedCount, setTotalClaimedCount] = React.useState(0);
  const handleLoadClaimTransactions = async () => {
    const res = await getRequest('get-claim-fund-transaction-data');
    if (res && res.code === 200) {
      // Group by p_id and sum dividend_amount
      const approvedTransactions = res.data.filter(tx => tx.status === 'Approved');

      const grouped = {};
      let totalCount = 0;
      approvedTransactions.forEach(tx => {
        if (!tx.p_id) return;
        if (!grouped[tx.p_id]) {
          grouped[tx.p_id] = {
            p_id: tx.p_id,
            property_name: tx.property_name ,
            total_claim_amount: 0,
            transactions: [],
          };
        }
        grouped[tx.p_id].total_claim_amount += parseFloat(tx.amount || 0);
        grouped[tx.p_id].transactions.push(tx);
        totalCount+=parseFloat(tx.amount || 0);
      });
      setClaimGrouped(Object.values(grouped));
      setTotalClaimedCount((totalCount).toFixed(2));
    }
  }

    const [ WithdrawalBreakdown, setWithdrawalBreakdown ] = React.useState([]);
    const handleLoadGetWithdrawalBreakdown = async () => {
      const res = await getRequest('get-withdrawal-breakdown');
      if (res && res.code === 200) {
        setWithdrawalBreakdown(res.data);
      }
    }

  React.useEffect(() => {
    handleLoadGetDashboardNumbers();
    handleLoadGetTransactionData();
    handleLoadDividendTransactions();
    handleLoadClaimTransactions();
    fetchAllBonuses();
    handleLoadGetWithdrawalBreakdown();
    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
    // eslint-disable-next-line
  }, []);

const [currentPage, setCurrentPage] = React.useState(1);
const rowsPerPage = 10;
const withdrawalData = WithdrawalBreakdown.withdrawBreakdown || [];

const totalPages = Math.ceil(withdrawalData.length / rowsPerPage);

const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;

const currentWithdrawals = withdrawalData.slice(
  indexOfFirstRow,
  indexOfLastRow
);

  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Dashboard")} />
          <Row>
            <Col xs="12">
              <Row>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.total_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                 <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Registration Pending Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.registration_Pending_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Active Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.active_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-check display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Inactive Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.inactive_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-x display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_kyc" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">KYC Verified Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.kyc_verified_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-check-shield display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_kyc" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">KYC Pending Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.kyc_pending_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-check display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/claim_fund" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Claim Fund Requests</h5>
                          <h4 className="mb-0">{DashboardNumbers.claim_fund_requests}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-money display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/transaction" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">No of Transactions</h5>
                          <h4 className="mb-0">{DashboardNumbers.no_of_transactions}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-list-ul display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/withdrawal_request" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Withdrawal Requests</h5>
                          <h4 className="mb-0">{DashboardNumbers.withdrawal_requests}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-transfer-alt display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>


          <Card>
            <CardBody>
              <h4 className="card-title mb-3">Bonus</h4>

              <div className="d-flex align-items-center gap-2 flex-wrap">

                {/* FROM DATE */}
                <div className="input-group" style={{ maxWidth: '260px' }}>
                  <DatePicker
                    selected={bonusDateFrom}
                    onChange={date => setBonusDateFrom(date)}
                    selectsStart
                    startDate={bonusDateFrom}
                    endDate={bonusDateTo}
                    placeholderText="From"
                    className="form-control border-start-0"
                    dateFormat="yyyy-MM-dd"
                    isClearable
                    calendarClassName="bg-white text-dark"
                    popperPlacement="bottom"
                  />
                </div>
                <span>-</span>
                  <div className="input-group" style={{ maxWidth: '260px' }}>
                  <DatePicker
                    selected={bonusDateTo}
                    onChange={date => setBonusDateTo(date)}
                    selectsEnd
                    startDate={bonusDateFrom}
                    endDate={bonusDateTo}
                    minDate={bonusDateFrom}
                    placeholderText="To"
                    className="form-control border-start-0"
                    dateFormat="yyyy-MM-dd"
                    isClearable
                    calendarClassName="bg-white text-dark"
                    popperPlacement="bottom"
                  />
                </div>
        

                <Button
                  color="primary"
                  onClick={handleBonusFilter}
                  disabled={bonusLoading}
                >
                  {bonusLoading ? "Filtering..." : "Filter"}
                </Button>
              </div>
              <Row className="mt-4 text-center">
                <Col md="2">
                  <h6>Total Bonus</h6>
                  <h4>€{TotalBonus}</h4>
                </Col>

                <Col md="2">
                  <h6>Welcome Bonus</h6>
                  <h4>€{WelcomeBonus}</h4>
                </Col>

                <Col md="2">
                  <h6>Referral Bonus</h6>
                  <h4>€{ReferralBonus}</h4>
                </Col>

                <Col md="2">
                  <h6>Manual Bonus</h6>
                  <h4>€{ManualBonus}</h4>
                </Col>

              </Row>

            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Col lg="12">
                <div className="h4 card-title">Collaborator Bonus</div>
                <div className="d-flex flex-wrap gap-3 ">
                  <div style={{ maxWidth: '350px' }}>
                    <Card className="bg-white text-dark shadow-sm border">
                      <CardBody className="d-flex align-items-center justify-content-between py-3">
                        <div>
                          <h5 className="mb-2">Total Collaborator Bonus</h5>
                          <h3 className="mb-0">€{CollaboratorBonus}</h3>
                        </div>
                        <div className="ms-3">
                          <i className="bx bx-money display-4 text-light"></i>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Col lg="12">
                <div className="h4 card-title">Property Dividend</div>
                <div className="d-flex flex-wrap gap-3 mb-4">
                  <div style={{ maxWidth: '350px' }}>
                    <Card className="bg-white text-dark shadow-sm border">
                      <CardBody className="d-flex align-items-center justify-content-between py-3">
                        <div>
                          <h5 className="mb-2">Total Dividend</h5>
                          <h3 className="mb-0">€{TotalDividendCount}</h3>
                        </div>
                        <div className="ms-3">
                          <i className="bx bx-bar-chart-alt-2 display-4 text-light"></i>

                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>

                <div className="table-rep-plugin">
                  <div className="table-responsive mb-0">
                    <table className="table mb-0" style={{ minWidth: '900px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>Property ID</th>
                          <th>Property Name</th>
                          <th>Total Dividend Amount</th>
                          <th>No. of Transactions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DividendGrouped.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center">No records found</td>
                          </tr>
                        ) : (
                          DividendGrouped.map((item, idx) => (
                            <tr key={idx}>
                              <td>{item.p_id}</td>
                              <td>{item.property_name}</td>
                              <td>€{item.total_dividend_amount.toFixed(2)}</td>
                              <td>{item.transactions.length}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Col lg="12">
                <div className="h4 card-title">Property Claimed</div>
                <div className="d-flex flex-wrap gap-3 mb-4">
                  <div style={{ maxWidth: '350px' }}>
                    <Card className="bg-white text-dark shadow-sm border">
                      <CardBody className="d-flex align-items-center justify-content-between py-3">
                        <div>
                          <h5 className="mb-2">Total Claimed</h5>
                          <h3 className="mb-0">€{TotalClaimedCount}</h3>
                        </div>
                        <div className="ms-3">
                          <i className="bx bx-bar-chart-alt-2 display-4 text-light"></i>

                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>

                <div className="table-rep-plugin">
                  <div className="table-responsive mb-0">
                    <table className="table mb-0" style={{ minWidth: '900px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>Property ID</th>
                          <th>Property Name</th>
                          <th>Total Claimed Amount</th>
                          <th>No. of Transactions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ClaimGrouped.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center">No records found</td>
                          </tr>
                        ) : (
                          ClaimGrouped.map((item, idx) => (
                            <tr key={idx}>
                              <td>{item.p_id}</td>
                              <td>{item.property_name}</td>
                              <td>€{item.total_claim_amount.toFixed(2)}</td>
                              <td>{item.transactions.length}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>

          {/* <Row className="mt-4">
  <Col xs="12">
    <div className="card">
      <div className="card-body">
        <h4 className="card-title">Withdrawal Traceability</h4>
        <p className="text-muted">
          Each bank withdrawal broken down by originating project
        </p>

        <div className="table-responsive">
          <table className="table align-middle table-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>DATE</th>
                <th>AMOUNT</th>
                <th>SOURCE BREAKDOWN (PER PROJECT)</th>
              </tr>
            </thead>
            <tbody>
              {currentWithdrawals.map((withdrawal, idx) => (
                <tr key={idx}>
                  <td>
                    <div className="font-size-13">{withdrawal.first_name}</div>
                  </td>
                  <td>
                    <div className="font-size-13">{withdrawal.last_name}</div>
                  </td>
                  <td>
                    <div className="font-size-13">
                      {moment(withdrawal.created_at).format('YYYY-MM-DD')}
                    </div>
                    <div className="text-muted font-size-12">
                      {moment(withdrawal.created_at).format('HH:mm')}
                    </div>
                  </td>
                  <td className="fw-bold">
                    €{Number(withdrawal.withdraw_amount).toFixed(2)}
                  </td>
                  <td style={{ minWidth: "300px" }}>
                    <div className="progress" style={{ height: "24px", borderRadius: "4px", backgroundColor: "#f0f0f0" }}>
                      {withdrawal.used && withdrawal.used.map((source, sIdx) => {
                        const widthPercent = (source.amount / withdrawal.withdraw_amount) * 100;
                        const colors = ["#036B41", "#4A90E2", "#8E7CC3", "#D98C2B"]; // Sequential colors
                        
                        return (
                          <div
                            key={sIdx}
                            className="progress-bar"
                            role="progressbar"
                            style={{ 
                              width: `${widthPercent}%`, 
                              backgroundColor: colors[sIdx % colors.length],
                              fontSize: "10px",
                              lineHeight: "24px",
                              fontWeight: "bold"
                            }}
                            title={`${source.propert_name}: €${Number(source.amount).toFixed(2)}`}
                          >
                            {widthPercent > 10 ? `${source.token_symbol?.split('-')[1] || 'PJ'} €${Number(source.amount).toFixed(2)}` : ""}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  
                </tr>
              ))}
              {(!WithdrawalBreakdown.withdrawBreakdown || WithdrawalBreakdown.withdrawBreakdown.length === 0) && (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-4">
                    No withdrawal records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="d-flex justify-content-between align-items-center mt-3">

  <div>
    Showing {indexOfFirstRow + 1} to{" "}
    {Math.min(indexOfLastRow, withdrawalData.length)} of{" "}
    {withdrawalData.length} entries
  </div>

  <div className="d-flex gap-2">

    <Button
      color="primary"
      size="sm"
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => prev - 1)}
    >
      Previous
    </Button>

    <div className="align-self-center">
      Page {currentPage} of {totalPages || 1}
    </div>

    <Button
      color="primary"
      size="sm"
      disabled={currentPage === totalPages || totalPages === 0}
      onClick={() => setCurrentPage(prev => prev + 1)}
    >
      Next
    </Button>

  </div>

</div>
        </div>
      </div>
    </div>
  </Col>
</Row> */}

          <Card>
            <CardBody>
              <Col lg="12">
                <div className="mb-4 h4 card-title">Latest Transactions</div>
                <div className="table-rep-plugin">
                  <div className="table-responsive mb-0">
                    <table className="table mb-0" style={{ minWidth: '1200px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email ID</th>
                          <th>Tokens</th>
                          <th>Currency</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {TransactionTBody}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Dividend Transactions Grouped by Property */}
                
              </Col>
            </CardBody>
          </Card>


          <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Transaction Details</h5>
              <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="mb-3">ID : <span className="text-primary">{Transaction.pct_id}	</span></p>
              <p className="mb-3">First Name : <span className="text-primary">{Transaction.first_name}	</span></p>
              <p className="mb-3">Last Name : <span className="text-primary">{Transaction.last_name}</span></p>
              <p className="mb-3">Email ID : <span className="text-primary">{Transaction.email}</span></p>
              <p className="mb-3">Tokens : <span className="text-primary">{Transaction.token}	</span></p>
              <p className="mb-3">Currency : <span className="text-primary">{Transaction.currency}</span></p>
              <p className="mb-3">Amount : <span className="text-primary">{parseFloat(Transaction.received_amount)} {Transaction.currency} {parseFloat(Transaction.used_euro_wallet_amount) !== 0? <b>( {Transaction.used_euro_wallet_amount} EUR spent from euro wallet )</b> : '' }</span></p>
              <p className="mb-3">Date : <span className="text-primary">{moment(Transaction.created_at).format('YYYY-MM-DD | HH:mm')}</span></p>
              <p className="mb-3">Status : <span className="text-primary"><span className={"font-size-14 badge bg-secondary rounded-pill " + (Transaction.status === 'Pending' ? 'badge-soft-warning' : Transaction.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{Transaction.status}</span></span></p>
              {Transaction.send_tx !== '' && Transaction.send_tx !== null?
              <p className="mb-3">Transaction Hash : <span className="text-primary"><br />{Transaction.send_tx}</span></p>
              : '' }
              {Transaction.transaction_proof !== '' && Transaction.transaction_proof !== null?
              <p className="mb-3">Transaction Proof : <span className="text-primary"><br /><a rel="noreferrer" target="_blank" href={`${process.env.REACT_APP_API_URL}${FilePath}${Transaction.transaction_proof}`} download={Transaction.transaction_proof}>{Transaction.transaction_proof}</a></span></p>
              : '' }
              {Transaction.transaction_information !== '' && Transaction.transaction_information !== null?
              <p className="mb-3">Transaction Information : <span className="text-primary"><br />{Transaction.transaction_information}</span></p>
              : '' }
            </div>
          </Modal>

        </Container>
      </div>

    </React.Fragment >
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
